import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { useConnectStore } from '../../../store/models';
import useConnectErrors from '../../../store/models/connect/errors/useConnectErrors';
import useModuleErrorDialog from '../../../store/models/error/useModuleErrorDialog';
import ActivePlanView from './views/activePlanView';
import PlansBrowseView from './views/plansBrowseView';
import ConnectPageSkeleton from './views/connectPageSkeleton';

function ConnectPage () {
    const connectStore = useConnectStore();
    const { errors } = useConnectErrors();
    const { renderErrorDialog } = useModuleErrorDialog({ errors });
    // Local, per-mount resolution flag — deliberately not derived from
    // observed.currentPlan (that uuid token stays truthy forever once set, so
    // on remount it would read as "resolved" using the *previous* mount's
    // stale currentPlan before this mount's getCurrentPlan() call finishes).
    const [currentPlanResolved, setCurrentPlanResolved] = useState(false);

    useEffect(() => {
        let cancelled = false;
        connectStore.getCurrentPlan().then(() => {
            if (!cancelled) {
                setCurrentPlanResolved(true);
            }
        });
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line
    }, []);

    const hasActivePlan = currentPlanResolved && !!connectStore.currentPlan;

    return (
        <React.Fragment>
            {!currentPlanResolved ? (
                <ConnectPageSkeleton />
            ) : hasActivePlan ? (
                <ActivePlanView currentPlan={connectStore.currentPlan} />
            ) : (
                <PlansBrowseView />
            )}
            {renderErrorDialog()}
        </React.Fragment>
    );
}

const ObservedConnectPage = observer(ConnectPage);
export default ObservedConnectPage;
